import { Box, IconButton, Link, Stack, Tooltip, Typography } from "@mui/material";
import { grey } from '@mui/material/colors';
import { DataGrid } from "@mui/x-data-grid";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import EditIcon from '@mui/icons-material/Edit';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import useModal from "../../common/hooks/useModal";
import clientService from "../../services/client.service";
import { useSnackbar } from 'notistack'
import { useHistory } from "react-router-dom";
import { formatDate } from "../../helpers";

export const AlbaranesTable = ({ rowsState, setRowsState }) => {
  const modal = useModal();
  const { enqueueSnackbar } = useSnackbar()
  const history = useHistory();

  const getDisplayDate = (value) => {
    const inputDate = new Date(value);
    if (Number.isNaN(inputDate.getTime())) return "";

    const isSameDay = (a, b) =>
      a.getFullYear() === b.getFullYear() &&
      a.getMonth() === b.getMonth() &&
      a.getDate() === b.getDate();

    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    if (isSameDay(inputDate, today)) return "Hoy";
    if (isSameDay(inputDate, yesterday)) return "Ayer";

    return formatDate(inputDate, "es-ES", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
  };

  const { rows, loading, total, pageSize } = rowsState;

  const columns = [
    {
      headerName: "Albarán",
      title: "numero_albaran_dev",
      field: "numero_albaran_dev",
      flex: 1,
      minWidth: 100,
      // Se muestra el numero de DEVOLUCION (DEV0027656), no el de reparto. Queda a null en las
      // cabeceras que creo el fichero de detalle, que no lo trae; en ese caso se cae al de
      // reparto para no dejar el enlace sin texto y por tanto invisible.
      renderCell: (params) => (
        <Stack>
          <Link color="primary" underline="hover" href={`/albaran/${params.row.id}`}>
            {params.row.numero_albaran_dev || params.row.numero_albaran}
          </Link>
        </Stack>
      ),
    },
    {
      headerName: "Fecha",
      title: "fecha_albaran",
      field: "fecha_albaran",
      flex: 1,
      minWidth: 90,
      renderCell: (params) => (
        <Stack>
          <Link color="primary" underline="hover" href={`/albaran/${params.row.id}`}>
            {getDisplayDate(params.value)}
          </Link>
        </Stack>
      ),
    },
    {
      headerName: "Devolución",
      field: "actions",
      type: "actions",
      width: 110,
      renderCell: (cellValues) => {
        return (
          <Stack direction="row" spacing={1} alignItems="center" justifyContent="center">
            <Tooltip title={cellValues.row.num_devoluciones > 0 ? "Informado" : "Pendiente"}>
              {cellValues.row.num_devoluciones > 0 ? (
                <CheckCircleIcon fontSize="medium" color="success" />
              ) : (
                <AccessTimeIcon fontSize="medium" color="action" />
              )}
            </Tooltip>
            <Tooltip title="Editar">
              <IconButton
                size="small"
                aria-label="Editar cliente"
                onClick={(evt) => history.push(`/albaran/${cellValues.id}`)}
              >
                <EditIcon />
              </IconButton>
            </Tooltip>
          </Stack>
        );
      },
    },
  ];

  return (
    <Box
      style={{ height: 470, width: "100%", marginBottom: 30 }}
      sx={{
        '& .row-informed': {
          backgroundColor: '#edf7ed',
        }
      }}
      >
      <DataGrid
        density="standard"
        rows={rows}
        columns={columns}
        rowCount={total}
        pageSize={pageSize}
        rowsPerPageOptions={[pageSize]}
        pagination
        paginationMode="server"
        onPageSizeChange={(pageSize) =>
          setRowsState((prev) => ({ ...prev, pageSize }))
        }
        onPageChange={(page) => {
          setRowsState((prev) => ({ ...prev, page }));
        }}
        loading={loading}
        components={{
          NoRowsOverlay: () => (
            <Stack height="100%" alignItems="center" justifyContent="center">
              No hay resultados
            </Stack>
          )
        }}
        getRowClassName={(params) => {
          if (params.row.num_devoluciones > 0) {
            return "row-informed";
          }
          return "";
        }}
      />
    </Box>
  );
};
